exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n\n  /*colors named by https://www.color-blindness.com/color-name-hue/*/\n\n  /*shadow*/\n\n  /*z-index*/\n\n  /*transition*/\n\n  /*radius*/\n\n  /*chat*/\n}\n\n._3WUQHJx {\n  display: inline-block;\n  min-width: 24px;\n  height: 24px;\n  line-height: 24px;\n  color: #fff;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 50%;\n}\n\n._1zCCPqI {\n    background: #C4C9CC;\n  }\n\n._3B2EMZZ {\n    background: #4dcd5e;\n  }\n", ""]);
// Exports
exports.locals = {
	"Label": "_3WUQHJx",
	"Label_gray": "_1zCCPqI",
	"Label_green": "_3B2EMZZ"
};